export enum FlowType {
  Customer = "customer",
  Business = "business",
  Availability = "availability",
}

export enum CustomerRouteStep {
  Services = "customerServices",
  ExistingSlots = "customerExistingSlots",
  Slots = "customerSlots",
  Success = "customerSuccess",
}

export enum BusinessRouteStep {
  PhoneInput = "businessPhoneInput",
  VerifyOtp = "businessVerifyOtp",
  Dashboard = "businessDashboard",
  Insights = "businessInsights",
  Info = "businessInfo",
  ServicesSetup = "businessServicesSetup",
  Authorize = "businessAuthorize",
  SlotsSetup = "businessSlotsSetup",
  Success = "businessSuccess",
}

export enum AvailabilityRouteStep {
  Check = "availabilityCheck",
  Slots = "availabilitySlots",
  Success = "availabilitySuccess",
}

export type AllRouteSteps =
  | CustomerRouteStep
  | BusinessRouteStep
  | AvailabilityRouteStep;

interface StepDependencyMap {
  [key: string]: AllRouteSteps[];
}

export const StepDependencies: StepDependencyMap = {
  [CustomerRouteStep.Services]: [],
  [CustomerRouteStep.ExistingSlots]: [],
  [CustomerRouteStep.Slots]: [],
  [CustomerRouteStep.Success]: [],

  [BusinessRouteStep.PhoneInput]: [],
  [BusinessRouteStep.VerifyOtp]: [BusinessRouteStep.PhoneInput],
  [BusinessRouteStep.Insights]: [],
  [BusinessRouteStep.Dashboard]: [BusinessRouteStep.VerifyOtp],
  [BusinessRouteStep.Info]: [BusinessRouteStep.VerifyOtp],
  [BusinessRouteStep.ServicesSetup]: [BusinessRouteStep.Info],
  [BusinessRouteStep.Authorize]: [BusinessRouteStep.ServicesSetup],
  [BusinessRouteStep.SlotsSetup]: [BusinessRouteStep.Authorize],
  [BusinessRouteStep.Success]: [BusinessRouteStep.SlotsSetup],

  [AvailabilityRouteStep.Check]: [],
  [AvailabilityRouteStep.Slots]: [AvailabilityRouteStep.Check],
  [AvailabilityRouteStep.Success]: [AvailabilityRouteStep.Slots],
};

// Map customer route steps to progress bar step numbers (1-3)
export const CustomerStepNumbers: Record<CustomerRouteStep, number> = {
  [CustomerRouteStep.Services]: 1,
  [CustomerRouteStep.ExistingSlots]: 1,
  [CustomerRouteStep.Slots]: 2,
  [CustomerRouteStep.Success]: 3,
};
